import { T, MANROPE } from "./todoTokens";

const CELLS = [
  { key: "open", label: "OPEN", color: T.ink, testid: "todos-strip-open" },
  { key: "overdue", label: "OVERDUE", color: T.overdue, testid: "todos-strip-overdue" },
  { key: "due_today", label: "DUE TODAY", color: T.dueToday, testid: "todos-strip-due-today" },
  { key: "in_progress", label: "IN PROGRESS", color: T.inProgress, testid: "todos-strip-in-progress" },
];

const plural = (n, w) => `${n} ${w}${n === 1 ? "" : "s"}`;

/* Directive §5 — company-wide figures that ignore the other filters, so the
   strip always shows the true totals. Cells are the quick filter. */
export const SummaryStrip = ({ summary, quick, onQuick, todayLabel }) => {
  const s = summary;
  const sub = {
    open: s ? `${s.in_progress} in progress` : "—",
    overdue: s ? plural(s.overdue_people, "person").replace("persons", "people") : "—",
    due_today: todayLabel,
    in_progress: s ? `of ${s.open} open` : "—",
  };
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 rounded-[10px] overflow-hidden"
      style={{ background: T.card, border: `1px solid ${T.cardEdge}` }} data-testid="todos-summary-strip">
      {CELLS.map((c, i) => {
        const on = quick === c.key || (!quick && c.key === "open");
        return (
          <button key={c.key} data-testid={c.testid}
            onClick={() => onQuick(quick === c.key ? null : c.key)}
            className="text-left px-5 py-3.5 transition-colors hover:bg-[#FBFAF7] relative"
            style={{
              borderLeft: i % 4 === 0 ? "none" : `1px solid ${T.rule}`,
              background: on ? "#FFFBEA" : undefined,
            }}>
            <div style={{ fontSize: 10.5, fontWeight: 700, letterSpacing: "0.12em", color: T.muted }}>{c.label}</div>
            <div className="mt-0.5" style={{ ...MANROPE, fontSize: 26, fontWeight: 800, color: c.color }}>
              {s ? s[c.key] : "—"}
            </div>
            <div className="text-[12px]" style={{ color: T.muted }}>{sub[c.key]}</div>
            {on && <span className="absolute left-0 right-0 bottom-0" style={{ height: 3, background: T.accent }} />}
          </button>
        );
      })}
    </div>
  );
};
